export default "__VITE_ASSET__52f5df50__"